<script>
    import Cookies from 'js-cookie'
    
	import { onMount } from 'svelte'
    import { VersionCheck, ServerCheck } from '../../script/_init'
    import { OnPageEnter } from '../../script/handle/home'

    let cookie = false, skipValue = false

	onMount(async () => {
        cookie = Cookies.get('ds_cookie')
    })

    function onEnter() {
        // 쿠키세팅 및 페이지 이동
        OnPageEnter(cookie, skipValue)
    }
</script>

{#if !($ServerCheck)}
    <div class="issue">
        서버 연동 실패<br>
        <a href="https://open.kakao.com/me/admin_turtle" rel="noopener noreferrer" target="_blank">관리자에게 제보 부탁드립니다.</a>
    </div>
{:else if !($VersionCheck)}
    <div class="issue">
        현재 페이지 버전과 서버 버전이 다릅니다.<br>
        쿠키(또는 인터넷 기록) 삭제 후 새로고침 해주세요.<br>
        서버가 불안정하기에 해당 현상이 계속된다면 관리자에게 제보 부탁드립니다.
    </div>
{/if}

<div class="enter">
    {#if Cookies.get('ds_cookie') == undefined || !Cookies.get('ds_cookie')}
        <label>
            <input type="checkbox" bind:checked={cookie} />
            <p>쿠키 이용 및 수집에 동의합니다.(필수)</p>
        </label>
    {/if}

    <label>
        <input type="checkbox" bind:checked={skipValue} />
        <p>다음 업데이트까지 보지 않기</p>
    </label>
    
    <button on:click={onEnter} disabled={!cookie || !($VersionCheck)} >들어가기</button>
</div>

<style lang="scss">
    .issue {
        margin-top: 20px;
        color: $cl4;
        font-size: 20px;
        font-family: aggro;
        text-align: center;
    }
    .enter {
        width: calc(100%);
        max-width: 1200px;
        height: fit-content;
        margin: 30px auto;
        text-align: center;

        button {
            background: none;
            margin-top: 30px;
            padding: 13px 33px 10px 33px;;
            border: 2px solid $cl3;
            color: $cl2;
            font-size: 20px;
            font-family: aggro;

            &:hover {
                background: $cl3;
            }
            &:disabled {
                background: $cl5;
                border: 2px solid $cl5;
                cursor: not-allowed;
            }
        }

        label {
            width: fit-content;
            margin: 0px auto;
            font-size: 14px;
            display: block;
            cursor: pointer;

            &:hover {
                p { color: $cl3; text-decoration: underline; }
            }

            input[type=checkbox] {
                vertical-align: middle;

                &:checked + p {
                    color: $cl3;
                }
            }
            
            p {
                margin: 0px 5px;
                display: inline-block;
                vertical-align: middle;
            }
        }
    }
</style>